import * as Yup from 'yup';
import { getTrimmedValue } from '../../../../../../../utils/utilities';
import { getNameValidationSchema } from '../../../../../../../utils/ValidationSchema';

export default Yup.object().shape({
  stayingPeriod: Yup.string().required('Please select Period of stay'),
  otherFullName: Yup.string().when('isCandidateAvailable', {
    is: 'no',
    then: getNameValidationSchema({
      message: 'Full name',
      isRequired: true
    })
  }),
  otherRelation: Yup.string().when('relation', {
    is: 'Other',
    then: Yup.string().required('Please enter relation')
  }),
  relativePhoneNumber: Yup.string().when('isCandidateAvailable', {
    is: 'no',
    then: Yup.string()
      .transform((currentVal) => getTrimmedValue(currentVal, false))
      .required('Please enter phone number')
  })
});
